import { render } from "./YearSettings.vue?vue&type=template&id=3ea3cdde"
import script from "./YearSettings.vue?vue&type=script&lang=js"
export * from "./YearSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__